/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-empty-function */
/* eslint-disable no-new */
/* eslint-disable eqeqeq */
/* eslint-disable no-empty */
/* eslint-disable no-restricted-globals */
/* eslint-disable radix */

import { paymentRequest, getStatementPaymentList, getPaymentInstrumentlist } from 'helpers/api';
import { UTILITIES, formatDate, formatMoney } from 'helpers/utils';
import swal from 'sweetalert';
import { isProd } from 'config/config';

import Vue from 'vue/dist/vue';

const paymentSuccessUrl = isProd ? `/portal` : '/dashboard.html';

const paymentsEl = document.querySelector('#payments');
if (paymentsEl) {
    new Vue({
        el: '#payments',
        data: {
            res: null,
            liElement: '',
            isLoading: true,
            searchFilter: '',
            pageSize: 50,
            currentPage: 1,
            paginationInput: 1,
            showCancelButton: false,
            FullName: null,
            formattedDate: '',
            mode: '',
            PaymentMethodIdSelected: null,
            paymentMethodsList: [],
            shortPayReason: [
                'Freight deduction',
                'Discount deduction',
                'Shortage deduction',
                'Damage deduction',
                'Credit in process deduction',
                'Partial payment shortage',
            ],
            errorMessage: null,
            pendingRecords: [],
            pendingRecordsMessage: null,
            showSelectedLines: false,
            isEmailValid: true,
        },

        computed: {
            paymentItems() {
                if (this.res) {
                    const searchFilterLower = this.searchFilter.toLowerCase();

                    if (this.showSelectedLines) {
                        return this.res.lines.filter((i) => {
                            return i.selected;
                        });
                    }

                    return this.res.lines.filter((i) => {
                        const searchString = `${i.purchaseOrder} ${i.name}`.toLowerCase();

                        return !this.searchFilter || searchString.indexOf(searchFilterLower) >= 0;
                    });
                }
                return [];
            },

            selectedInvoiceTotal() {
                let selectedTotal = 0;
                for (let i = 0; i < this.res.lines.length; i++) {
                    const element = this.res.lines[i];
                    if (element.selected && element.type == 'customrecord_nsts_ci_consolidate_invoice') {
                        if (this.ValidatePaymentAmount(element)) {
                            const paymentAmountData = parseFloat(element.paymentAmount);
                            console.log(element.name, paymentAmountData);
                            if (element.selected && !isNaN(paymentAmountData)) {
                                selectedTotal += paymentAmountData;
                            }
                        }
                    }
                }
                if (isNaN(selectedTotal)) {
                    selectedTotal = 0;
                }

                if (selectedTotal < 0) {
                    return 0;
                }
                return selectedTotal;
            },
            selectedCreditTotal() {
                let selectedTotal = 0;
                for (let i = 0; i < this.res.lines.length; i++) {
                    const element = this.res.lines[i];
                    if (element.selected && (element.type == 'CustCred' || element.type == 'CustDep' || element.type == 'CustPymt')) {
                        selectedTotal += parseFloat(element.amount);
                    }
                }
                return selectedTotal;
            },

            netPaymentAmount() {
                const netTotal = this.selectedInvoiceTotal - Math.abs(this.selectedCreditTotal);
                if (netTotal <= 0) {
                    return 0;
                }
                return netTotal;
            },

            // NOTE: Credits, deposits and unapplied payments can only be applied against an invoice.
            isCreditOnlySelection() {
                if (!this.res || !this.res.lines) {
                    return false;
                }

                const creditTypes = ['CustCred', 'CustDep', 'CustPymt'];

                const selectedLines = this.res.lines.filter((i) => {
                    return i.selected;
                });

                return (
                    selectedLines.length > 0 &&
                    selectedLines.every((i) => {
                        return creditTypes.indexOf(i.type) >= 0;
                    })
                );
            },

            disablePreviousLink() {
                return this.currentPage <= 1;
            },

            disableNextLink() {
                return this.currentPage >= this.totalNumOfPages;
            },

            visiblePaymentItems() {
                return this.paymentItems.slice((this.currentPage - 1) * this.pageSize, (this.currentPage - 1) * this.pageSize + this.pageSize);
            },

            totalNumOfPages() {
                const filledPages = Math.floor(this.paymentItems.length / this.pageSize);
                const remainder = this.paymentItems.length % this.pageSize;

                if (remainder) {
                    return filledPages + 1;
                }
                return filledPages;
            },

            visiblePaymentItemsLow() {
                if (!this.paymentItems.length) {
                    return 0;
                }
                return this.pageSize * this.currentPage - (this.pageSize - 1);
            },

            visiblePaymentItemsHigh() {
                if (this.currentPage == this.totalNumOfPages) {
                    return this.paymentItems.length;
                }
                return this.currentPage * this.pageSize;
            },

            selectedPaymentMethod() {
                const selectedPayment = this.PaymentMethodIdSelected;
                const index = this.paymentMethodsList.findIndex((x) => {
                    return x.value == selectedPayment;
                });
                if (index > -1) {
                    return this.paymentMethodsList[index];
                }
                return { text: 'No Payment Selected', value: -1 };
            },
        },

        filters: {
            formatMoney(price) {
                if (price < 0) {
                    const formatPrice = formatMoney(Math.abs(price));

                    return '(' + formatPrice + ')';
                }
                return formatMoney(price);
            },
        },

        methods: {
            async setValues() {
                // Get Payment method for customer
                const paymentInstList = await getPaymentInstrumentlist();

                if (paymentInstList.status == 200) {
                    for (let index = 0; index < paymentInstList.data.length; index++) {
                        const paymentInst = paymentInstList.data[index];
                        const payment = {
                            text: paymentInst.mask,
                            value: paymentInst.id,
                        };
                        this.paymentMethodsList.push(payment);
                    }
                }

                // Get Statement|Invoice Payment List
                const response = await getStatementPaymentList();

                if (UTILITIES.urlParameters != null && UTILITIES.urlParameters.mode != null && UTILITIES.urlParameters.mode.length > 0) {
                    const { mode } = UTILITIES.urlParameters;

                    // eslint-disable-next-line prefer-destructuring
                    this.mode = mode[0];
                }

                Vue.set(this, 'pendingRecordsMessage', null);
                Vue.set(this, 'pendingRecords', []);

                if (response.status == 200) {
                    if (!response.data.lines || !response.data.lines.length) {
                        this.errorMessage = 'There are no open invoices for payment.'; // response.data.errorMessage
                        this.res = response.data.data;
                    } else {
                        this.res = response.data;

                        if (response.pendingRecordsMessage != null) {
                            Vue.set(this, 'pendingRecordsMessage', response.pendingRecordsMessage);
                        }

                        if (response.pendingRecords != null) {
                            Vue.set(this, 'pendingRecords', response.pendingRecords);
                        }

                        Vue.set(this.res, 'ReferenceNumber', null);

                        if (this.mode != null && this.mode == 'statement') {
                            this.prefillItems('current');
                        }
                    }
                } else if (response.status == 400) {
                    this.errorMessage = response.data.Message;
                }

                this.isLoading = false;
            },

            previousPage() {
                this.currentPage -= 1;
                this.paginationInput = this.currentPage;
            },

            nextPage() {
                this.currentPage += 1;
                this.paginationInput = this.currentPage;
            },

            validatePaginationInput() {
                if (this.paginationInput === '') {
                } else if (isNaN(this.paginationInput) || this.paginationInput > this.totalNumOfPages || this.paginationInput <= 0) {
                    this.paginationInput = this.currentPage;
                } else {
                    const input = parseInt(this.paginationInput);
                    this.currentPage = input;
                    this.paginationInput = input;
                }
            },

            refreshPage() {
                if (this.paymentItems) {
                    this.currentPage = 1;
                    this.paginationInput = 1;
                } else {
                }
            },

            addDays(date, days) {
                const result = new Date(date);
                result.setDate(result.getDate() + days);
                const formatted = `${result.getMonth() + 1}/${result.getDate()}/${result.getFullYear()}`;
                return formatted;
            },

            prefillItems(range) {
                const now = new Date();
                const formattedDate = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
                const formattedDateDate = new Date(formattedDate);
                const formattedDateDateThrity = new Date(this.addDays(formattedDate, 30));

                this.showCancelButton = false;

                for (let index = 0; index < this.res.lines.length; index++) {
                    const ld = this.res.lines[index];
                    const duedateDate = new Date(ld.duedate);
                    Vue.set(ld, 'selected', false);

                    if (range == 'reset') {
                        Vue.set(ld, 'paymentAmount', ld.amount);
                        // this.showCancelButton = false;
                        continue;
                    }

                    if (duedateDate < formattedDateDate && (range == 'past' || range == 'pastAndCurrent')) {
                        if (range == 'past' && ld.type != 'customrecord_nsts_ci_consolidate_invoice') {
                            continue;
                        }
                        Vue.set(ld, 'selected', true);
                        this.showCancelButton = true;
                    }

                    if (range == 'current' && duedateDate >= formattedDateDate && duedateDate <= formattedDateDateThrity) {
                        Vue.set(ld, 'selected', true);
                        this.showCancelButton = true;
                    }

                    if ((range == 'pastAndCurrent' && duedateDate >= formattedDateDate && duedateDate <= formattedDateDateThrity) || !ld.duedate) {
                        Vue.set(ld, 'selected', true);
                        this.showCancelButton = true;
                    }
                    if (range == 'future') {
                        Vue.set(ld, 'selected', true);
                        this.showCancelButton = true;
                    }
                }
            },

            selectLine(item, index) {
                Vue.set(item, 'selected', !item.selected);
                Vue.set(item, 'paymentAmount', item.amount);
                for (let i = 0; i < this.res.lines.length; i++) {
                    const element = this.res.lines[i];
                    if (element.selected) {
                        this.showCancelButton = true;
                        return;
                    }
                }
                this.showCancelButton = false;
            },

            async SubmitPaymentRequest() {
                const netsuitePayment = {};
                const NetSuitePaymentLines = [];

                if (this.pendingRecords != null && this.pendingRecords.length > 0) {
                    swal({
                        title: 'Pending Payments',
                        text: 'You have a pending payment, please try again later.',
                        icon: 'warning',
                        dangerMode: true,
                    });

                    return;
                }

                if (this.pendingRecordsMessage == 'Not Bill To Account') {
                    swal({
                        title: 'Online Bill Pay setup',
                        text: 'Your account is not set up for Online Payments. \n Please contact Power Distributors to set this up by emailing creditdept@powerdistributors.com \n or by phone at 800-554-3336',
                        icon: 'warning',
                        dangerMode: true,
                    });

                    return;
                }

                if (this.isCreditOnlySelection) {
                    await swal({
                        title: 'Credit Cannot Be Processed',
                        text: 'To receive credit returned to you, please contact our Accounts Receivable department at 800-554-3336.',
                        icon: 'error',
                        dangerMode: true,
                    });

                    this.prefillItems('reset');

                    return;
                }

                this.isEmailValid = this.validateEmail(this.res.emailRecipient);
                if (!this.isEmailValid) {
                    swal('Invalid Email', 'Please enter a valid email address.', 'warning');
                    return;
                }

                for (let index = 0; index < this.res.lines.length; index++) {
                    const item = this.res.lines[index];

                    if (item.selected) {
                        item.paymentAmount = parseFloat(item.paymentAmount);

                        if (!this.ValidatePaymentAmount(item)) {
                            swal('Required', 'Please Enter an amount between $0.01 and ' + formatMoney(item.amount), 'warning');
                            return;
                        }

                        if (this.ShowShortReason(item) && !item.shortPayReasonSelected) {
                            swal('Required', 'Please select Short Pay Reason.', 'warning');
                            return;
                        }

                        const retPaymentItems = {
                            // Amount : item.amount,
                            Amount: item.paymentAmount,
                            InvoiceNumber: item.name,
                            PONumber: item.purchaseOrder,
                            Installment: item.installment,
                            Type: item.type,
                            ShortPayReason: item.shortPayReasonSelected,
                        };

                        // if (item.type == "CustCred") {
                        //   retPaymentItems.ShortPayReason = "Credit"
                        // }

                        // if (item.type == "CustDep") {
                        //   retPaymentItems.ShortPayReason = "Deposit"
                        // }

                        NetSuitePaymentLines.push(retPaymentItems);
                    }
                }

                netsuitePayment.NetSuitePaymentLines = NetSuitePaymentLines;
                netsuitePayment.NetPaymentAmount = this.netPaymentAmount;
                netsuitePayment.SelectedInvoiceTotal = this.selectedInvoiceTotal;
                netsuitePayment.SelectedCreditTotal = this.selectedCreditTotal;
                netsuitePayment.Name = this.FullName;
                netsuitePayment.Email = this.res.emailRecipient;
                netsuitePayment.PaymentMethodId = this.PaymentMethodIdSelected;
                netsuitePayment.PaymentMethodMasked = this.selectedPaymentMethod.text;
                netsuitePayment.PaymentInstrumentType = this.selectedPaymentMethod.InstrumentType;
                // netsuitePayment.Amount = this.netPaymentAmount

                if (netsuitePayment.Name == null || netsuitePayment.Name == '') {
                    swal('Required', 'Name is required field.', 'warning');
                    return;
                }

                if (netsuitePayment.Email == null || netsuitePayment.Email == '') {
                    swal('Required', 'Email is required field.', 'warning');
                    return;
                }

                if (netsuitePayment.PaymentMethodId == null || netsuitePayment.PaymentMethodId == '') {
                    swal('Required', 'Please select Payment Method.', 'warning');
                    return;
                }

                if (netsuitePayment.NetSuitePaymentLines.length == 0) {
                    swal('Required', 'Please select item(s) for payment submission.', 'warning');
                    return;
                }

                await swal({
                    title: 'Are you sure you want to submit this payment request?',
                    text: '',
                    icon: 'warning',
                    buttons: ['Go Back', 'Submit Payment'],
                    dangerMode: true,
                })
                    .then(async (willPost) => {
                        if (willPost) {
                            this.isLoading = true;
                            const postRequest = await paymentRequest(netsuitePayment);
                            if (postRequest.status === 200) {
                                const referenceNumber = postRequest.data.ReferenceNumber;
                                this.isLoading = false;
                                swal({
                                    title: 'Payment Request Submitted Successfully',
                                    text: 'Your Reference Number is ' + referenceNumber,
                                    type: 'success',
                                    icon: 'info',
                                });
                                this.res.ReferenceNumber = referenceNumber;
                                this.showSelectedLines = true;
                            } else if (postRequest.status === 400) {
                                const errorMessage = postRequest.data && postRequest.data.Message ? postRequest.data.Message : 'An unexpected error occurred.';
                                swal({
                                    title: 'Error',
                                    text: errorMessage,
                                    icon: 'error',
                                }).then(() => {
                                    window.location.reload();
                                });
                            } else {
                                // Handle other potential errors or unexpected status codes
                                swal({
                                    title: 'Unexpected Error',
                                    text: 'An unexpected error occurred. Please try again later.',
                                    icon: 'error',
                                });
                            }
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            },

            CanChangeAmount(item) {
                return (
                    item.selected &&
                    this.mode != 'statement' &&
                    item.type != 'CustCred' &&
                    item.type != 'CustDep' &&
                    item.type != 'CustPymt' &&
                    !this.res.ReferenceNumber
                );
            },

            ShowShortReason(item) {
                // NOTE: If PaymentAmount less than Amount and PaymentAmount is Positive value
                const paymentAmountData = parseFloat(item.paymentAmount);
                const amountData = parseFloat(item.amount);

                if (item.selected && this.mode == 'invoice' && item.type != 'CustCred' && item.type != 'CustDep' && item.type != 'CustPymt') {
                    if (paymentAmountData != amountData && paymentAmountData < amountData) {
                        return true;
                    }
                }
                return false;
            },

            ValidatePaymentAmount(item) {
                // NOTE: If Amount > PaymentAmount & PaymentAmount is Negative value
                const paymentAmountData = parseFloat(item.paymentAmount);
                const amountData = parseFloat(item.amount);
                if (item.selected && this.mode == 'invoice' && item.type != 'CustCred' && item.type != 'CustDep' && item.type != 'CustPymt') {
                    if (paymentAmountData != amountData && paymentAmountData > amountData) {
                        return false;
                    }
                    if (paymentAmountData < parseFloat(0)) {
                        return false;
                    }
                }
                return true;
            },

            formatDate(date, type) {
                if (type == 'CustCred') {
                    return 'Credit';
                } else if (type == 'CustDep') {
                    return 'Deposit';
                } else if (!date) {
                    return 'Pending';
                }
                return formatDate(date);
            },

            validateEmail(email) {
                const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return regex.test(email);
            },
        },
        created() {
            this.setValues();
        },
        actions: {},
    });
}

async function init() {}

export default init;
